module.exports = __webpack_public_path__ + "img/bgc1.abd3160a.png";